import React from 'react';
import { Modal as AntdModal } from 'antd';
import styles from './Modal.module.scss';
import { CrossIcon } from '../all-icons/custom-icons';

const Modal = ({
  open,
  handleCancel = () => {},
  handleOk = () => {},
  ModalBody,
  title,
  width = 1000,
  showActions = false,
  okText = 'Submit',
  cancelText = 'Cancel',
  closable = true,
  showCustomFooter = false,
  customFooter = [],
  destroyOnClose = false,
  bodyAsFunction = false,
  okButtonProps = {},
  maskClosable = true,
  modalStyles: modalStyle,
  extraStyles = {},
  titleStyles = {},
  modalWrap = null,
  zIndex = 1000,
}) => {
  const modalStyles = {
    header: {
      padding: '0px',
      borderBottom: '1px solid transparent',
    },
    body: {
      marginTop: '24px',
      marginBottom: '28px',
      padding: '0px',
    },
    footer: {
      borderTop: '1px solid transparent',
      padding: '0px',
    },
    content: {
      borderRadius: '24px',
      padding: '24px',
      border: '1px solid var(--user-card-border)',
    },
    ...extraStyles,
  };

  const renderTitle = () => (
    <div style={titleStyles} className={`${styles.title}`}>
      {title}
    </div>
  );

  const renderCloseIcon = () => <CrossIcon size={24} style={{ color: 'var(--text-main)' }} />;

  return (
    <AntdModal
      title={renderTitle()}
      open={open}
      onOk={handleOk}
      closable={closable}
      centered
      maskClosable={maskClosable}
      width={width}
      onCancel={(event) => {
        event.stopPropagation();
        handleCancel();
      }}
      {...(!showActions && !showCustomFooter
        ? { footer: null }
        : showCustomFooter && !showActions && { footer: customFooter })}
      styles={modalStyles}
      style={modalStyle}
      okText={okText}
      cancelText={cancelText}
      destroyOnClose={destroyOnClose}
      okButtonProps={{ ...okButtonProps, size: 'default' }}
      cancelButtonProps={{ size: 'default' }}
      rootClassName={modalWrap ?? styles.modalWrap}
      closeIcon={renderCloseIcon()}
      zIndex={zIndex}
    >
      {bodyAsFunction ? <ModalBody /> : ModalBody}
    </AntdModal>
  );
};

export default Modal;
